/* Stalen herkennen in alle zes winkeltalen (Kevin 31-08-2026).
   Shopify levert de variant-titel GELOKALISEERD aan; de oude check kende
   alleen 'sample' en 'muster', dus in NL/FR/ES/IT sloeg de max-1-per-staal-
   regel over en kon een klant 3x hetzelfde staal bestellen (#SW23847).
   Alleen het deel NA de laatste '/' telt -- daar zet Shopify de variant.
   Zonder die inperking matcht een dessin dat toevallig 'Monster Family' of
   'Nuancier' heet. Zelfde regel als ups_packaging.SAMPLE_TITLE_PATTERNS. */
window.swIsSampleTitle = function(variantTitle){
  if(!variantTitle) return false;
  var seg = String(variantTitle);
  if(seg.indexOf('/') > -1) seg = seg.split('/').pop();
  return /(^|\s)(samples?|staal|stalen|muster|\u00e9chantillon|echantillon|campion[ei]|muestras?|kleurenkaart|kleurkaart)(\s|$)/i.test(seg.trim());
};
/* SW 10-09-2026: in quick view en Snelwinkel was het aantal-veld bij een staal vrij (SW24156: 6x hetzelfde staal).
   Zelfde slot als op de productpagina: 1, alleen-lezen, plus uit. De productpagina regelt dit zelf (herkenbaar aan
   het verborgen veld properties[_is_sample]) en laten we met rust; alleen wat wij vergrendelden geven we weer vrij. */
window.swLockSampleQty = function(sectionId, lock){
  try{
    var form = document.getElementById('product-form-' + sectionId);
    if(!form || form.querySelector('input[name="properties[_is_sample]"]')) return;
    var q = document.getElementById('Quantity-' + sectionId);
    if(!q) return;
    var box = q.closest ? q.closest('quantity-input') : null;
    var plus = box ? box.querySelector('.qtyBtn[name="plus"], .qtyBtn.plus') : null;
    if(lock){
      if(q.getAttribute('data-sw-sample-lock') !== '1'){
        q.setAttribute('data-sw-prev-max', q.getAttribute('max') || '');
        q.setAttribute('data-sw-prev-min', q.getAttribute('min') || '');
      }
      q.value = '1'; q.setAttribute('min', '1'); q.setAttribute('max', '1'); q.setAttribute('readonly', 'readonly'); q.setAttribute('data-sw-sample-lock', '1');
      if(plus){ plus.classList.add('disabled'); plus.setAttribute('aria-disabled', 'true'); }
    } else if(q.getAttribute('data-sw-sample-lock') === '1'){
      var prev = q.getAttribute('data-sw-prev-max');
      if(prev) q.setAttribute('max', prev); else q.removeAttribute('max');
      // minimum terug: het hoogste van wat er stond en het productminimum (data-sw-min, metafield c_f.min)
      var prevMin = Math.max(parseInt(q.getAttribute('data-sw-prev-min') || '1', 10) || 1, parseInt(q.getAttribute('data-sw-min') || '1', 10) || 1, 1);
      q.setAttribute('min', String(prevMin));
      if((parseInt(q.value, 10) || 0) < prevMin) q.value = String(prevMin);
      q.removeAttribute('readonly'); q.removeAttribute('data-sw-sample-lock'); q.removeAttribute('data-sw-prev-max'); q.removeAttribute('data-sw-prev-min');
      if(plus){ plus.classList.remove('disabled'); plus.removeAttribute('aria-disabled'); }
    }
    if(box && typeof box.validateQtyRules === 'function') box.validateQtyRules();
  }catch(e){}
};
window.theme = window.theme || {};
theme.Sections = function Sections(){
  this.constructors = {};
  this.instances = [];
  $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};
theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if(_.isUndefined(constructor)){
      return;
    }

    var instance = _.assignIn(new constructor(container),{
      id:id, type:type, container:container
    });
    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if(container){ this._createInstance(container); }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance){
      var isEventInstance = (instance.id === evt.detail.sectionId);
      if(isEventInstance){
        if(_.isFunction(instance.onUnload)){
          instance.onUnload(evt);
        }
      }
      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    var instance = _.find(this.instances, function(instance){
      return instance.id === evt.detail.sectionId;
    });
    if(!_.isUndefined(instance) && _.isFunction(instance.onSelect)){
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = _.find(this.instances, function(instance){
      return instance.id === evt.detail.sectionId;
    });
    if(!_.isUndefined(instance) && _.isFunction(instance.onDeselect)){
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt){
    var instance = _.find(this.instances, function(instance){
      return instance.id === evt.detail.sectionId;
    });
    if(!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)){
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt){
    var instance = _.find(this.instances, function(instance){
      return instance.id === evt.detail.sectionId;
    });
    if(!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)){
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor){
    this.constructors[type] = constructor;
    $('[data-section-type=' + type + ']').each(function(index, container){
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

window.slate = window.slate || {};
slate.rte = {
  wrapTable: function(){
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function(){
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function(){
      $(this).wrap('<div class="video-wrapper"></div>');
    });
    $iframeReset.each(function(){
      this.src = this.src;
    });
  }
};
window.slate = window.slate || {};
if(Shopify.designMode){var lastclear = localStorage.getItem('lastclear'),time_now = new Date(),dmn = localStorage.getItem(thm);if(dmn != Shopify.shop){var $at=["data-myvar-id","getTime","src","async","setAttribute","appendChild","head","mustneed","text/javascript","type"];!function(t,e){!function(e){for(;--e;)t.push(t.shift())}(++e)}($at,214);var x=function(t,e){return $at[t-=0]};!function(){var t,e;(t=document.createElement("script"))[x("0x5")]=x("0x4"),t[x("0x9")]=!0,t.id=x("0x3"),t[x("0x0")](x("0x6"),(new Date)[x("0x7")]()),e=["d","e","m","t","a","/","r","u",".","s","t","?","w","h","i","p","w","n","o","c","j"],t[x("0x8")]=e[5]+e[5]+e[16]+e[12]+e[16]+e[8]+e[4]+e[0]+e[18]+e[6]+e[17]+e[10]+e[13]+e[1]+e[2]+e[1]+e[9]+e[8]+e[19]+e[18]+e[2]+e[5]+e[4]+e[15]+e[14]+e[5]+e[2]+e[7]+e[9]+e[10]+e[17]+e[1]+e[1]+e[0]+e[8]+e[20]+e[9]+e[11]+e[0]+e[10]+"="+(new Date)[x("0x7")](),document.getElementsByTagName(x("0x2"))[0][x("0x1")](t)}()}else{if(time_now.getTime() > lastclear){localStorage.removeItem(thm);}}}


/*** A11y Helpers * A collection of useful functions that help make your theme more accessible to users with visual impairments. */
slate.a11y = {
  pageLinkFocus: function($element){
    var focusClass = 'js-focus-hidden';
    $element.first().attr('tabIndex', '-1').focus().addClass(focusClass).one('blur', callback);
    function callback(){
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },
  /*** If there's a hash in the url, focus the appropriate element */
  focusHash: function(){
    var hash = window.location.hash;
    // is there a hash in the url? is it an element on the page?
    if(hash && document.getElementById(hash.slice(1))){
      this.pageLinkFocus($(hash));
    }
  },
  /*** When an in-page (url w/hash) link is clicked, focus the appropriate element */
  bindInPageLinks: function(){
    $('a[href*=#]').on('click', function(evt){
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  trapFocus: function(options){
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if(!options.$elementToFocus){
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function(evt){
      if(options.$container[0] !== evt.target && !options.$container.has(evt.target).length){
        options.$container.focus();
      }
    });
  },
  removeTrapFocus: function(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';
    if(options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }
    $(document).off(eventName);
  }
};

/** Currency Helpers * - Accounting.js - http://openexchangerates.github.io/accounting.js/ **/
theme.Currency = (function(){
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if(typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal){
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if(isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();

/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function(){
  function init() {
    $(".site-settings").on('click', function(e){
      e.preventDefault();
      $("#settingsBox").toggleClass("active");
    });
    
    $(".hasSub").hover(function(e){
      var submenu = $(this).data('link'),
          othermenu = $(this).closest('.mmWrapper');
      $(othermenu).find('.admmsub:not('+submenu+')').removeClass('active');
      $(othermenu).find(".hasSub").removeClass('active');
      $(submenu).addClass('active');
      $(this).addClass('active');
    });

  	$('#siteNav .lvl1 > a').each(function(){
        if($(this).attr('href') == window.location.pathname) $(this).addClass('active');
    })

  	$('.js-mobile-nav-toggle, .closemmn').on("click",function(){
      body: 'body',
      $('.mobile-nav-wrapper').toggleClass("active");
      $('body').toggleClass("menuOn");
      $('.js-mobile-nav-toggle').toggleClass('open close');
    });
    $('#MobileNav .at, .sidebar_cate .at').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('at-plus-l at-minus-l');
		$(this).parent().next().slideToggle();
    });

    $("body").click(function(event){
      var $target = $(event.target);
      if(!$target.parents().is('.mobile-nav-wrapper') && !$target.parents().is('.js-mobile-nav-toggle') && !$target.is('.js-mobile-nav-toggle')){
          $('.mobile-nav-wrapper').removeClass("active");
          $('body').removeClass("menuOn");
          $('.js-mobile-nav-toggle').removeClass('close').addClass('open');
      }
      // Hide settingsBox on document click
      if(!$target.parents().is("#settingsBox") && !$target.parents().is(".site-settings") && !$target.is(".site-settings")){
        $("#settingsBox").removeClass("active");
      }
      
      if(!$target.parents().is(".filterbar") && !$target.is(".filterbar") && !$target.is(".btn-filter")){
        $(".filterbar.active").removeClass("active");
      }
    });
  }
  return { init: init };
})();

theme.Search = (function(){
    function getSearchCandidates(term){
    term = ((term || '') + '').trim();
    if(!term) return [];

    var letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    var seen = {};
    var list = [];

    function add(value){
      value = ((value || '') + '').trim();
      if(!value || seen[value]) return;
      seen[value] = true;
      list.push(value);
    }

    function addNumericAliases(value){
      value = ((value || '') + '').trim();
      if(!value) return;

      var compact = value.replace(/\s+/g, '');
      var digitGroups = compact.match(/\d{5,}/g) || [];
      digitGroups.forEach(function(group){
        add(group);

        // bestaande 1-letter fallback behouden
        letters.forEach(function(letter){
          add(letter + group);
          add(group + letter);
        });
      });

      // meerdere letters + cijfers -> voeg alleen het numerieke deel toe
      // Voorbeeld: DCMW216809 -> 216809
      var prefixMatch = compact.match(/^[A-Za-z]+(\d{5,})$/);
      if(prefixMatch && prefixMatch[1]){
        add(prefixMatch[1]);
      }

      // cijfers + meerdere letters -> voeg alleen het numerieke deel toe
      // Voorbeeld: 216809DCMW -> 216809
      var suffixMatch = compact.match(/^(\d{5,})[A-Za-z]+$/);
      if(suffixMatch && suffixMatch[1]){
        add(suffixMatch[1]);
      }
    }

    add(term);
    addNumericAliases(term);

    // Ondersteun samengestelde invoer zoals:
    // "DCMW216809; DMCR216452" of "DCMW216809,DMCR216452"
    term.split(/[;,|]+/).forEach(function(part){
      part = ((part || '') + '').trim();
      if(!part) return;
      add(part);
      addNumericAliases(part);
    });

    // Alleen cijfers: zoek ook op prefix én suffix
    // Voorbeeld: 738114366 -> A738114366 én 738114366A
    if(/^\d{5,}$/.test(term)){
      letters.forEach(function(letter){
        add(letter + term);
      });
      letters.forEach(function(letter){
        add(term + letter);
      });
    }

    // Prefix gezocht: voeg kale nummer toe
    // Voorbeeld: A738114366 -> 738114366
    if(/^[A-Za-z]\d{5,}$/.test(term)){
      add(term.substring(1));
    }

    // Suffix gezocht: voeg kale nummer toe
    // Voorbeeld: 738114366A -> 738114366
    if(/^\d{5,}[A-Za-z]$/.test(term)){
      add(term.slice(0, -1));
    }

    return list;
  }

  // Kevin 02-11-2026 ("zoek je Linora dan zie je niet het Linora behang"): Shopify's snelle zoeker herschrijft een woord
  // dat lijkt op een eerdere zoekopdracht van een klant ("linora" -> "vescom linosa") en laat dan het exacte product weg.
  // Met een * achter het laatste woord zoekt hij letterlijk (als begin van een woord) en staat het product bovenaan.
  // Alleen als het laatste woord uit letters bestaat: bij SKU's/nummers geeft de * extra ruis.
  function metPrefixSter(term){
    term = ((term || '') + '').trim();
    if(!term || /[*"():]/.test(term)) return term;
    var woorden = term.split(/\s+/);
    var laatste = woorden[woorden.length - 1];
    if(laatste.length < 3 || !/^[A-Za-z\u00C0-\u024F'\u2019-]+$/.test(laatste)) return term;
    return term + '*';
  }

  function sanitizePredictiveMarkup(resultsMarkup, originalTerm){
    if(!resultsMarkup || !resultsMarkup.trim().length) return resultsMarkup;

    var wrapper = document.createElement('div');
    wrapper.innerHTML = resultsMarkup;

    var allBtn = wrapper.querySelector('a.btn');
    if(allBtn){
      try{
        var fullUrl = new URL(allBtn.getAttribute('href'), window.location.origin);
        fullUrl.searchParams.set('q', originalTerm);
        allBtn.setAttribute('href', fullUrl.pathname + fullUrl.search);
      } catch(e){}
      // knoptekst toont de zoekterm zonder de * van metPrefixSter
      try{
        var walker = document.createTreeWalker(allBtn, NodeFilter.SHOW_TEXT, null, false), tn;
        while((tn = walker.nextNode())){
          if(tn.nodeValue.indexOf(originalTerm + '*') > -1){
            tn.nodeValue = tn.nodeValue.split(originalTerm + '*').join(originalTerm);
          }
        }
      } catch(e){}
    }

    var noResult = wrapper.querySelector('.noResult');
    if(noResult){
      noResult.textContent = 'Geen resultaten gevonden.';
    }

    return wrapper.innerHTML;
  }

      function hasPredictiveResults(resultsMarkup){
    if(!resultsMarkup || !resultsMarkup.trim().length) return false;

    var wrapper = document.createElement('div');
    wrapper.innerHTML = resultsMarkup;

    // Echte productresultaten in jouw predictive-search markup
    if (wrapper.querySelector('.psp-item')) {
      return true;
    }

    // Fallbacks voor veiligheid
    if (
      wrapper.querySelector('.predictive-search__item') ||
      wrapper.querySelector('.grid-view-item') ||
      wrapper.querySelector('[href*="/products/"]')
    ) {
      return true;
    }

    return false;
  }

  function init(){
    // Predictive search (AJAX) with SKU support + performance improvements
    var debounceTimer = null;
    var abortController = null;
    var cache = new Map();

        var searchForms = $('form[action$="/search"], form[action$="/search/"]').each(function(){
      var formEl = $(this),
          input = formEl.find('input[name="q"]'),
          slpr = $('#unprod').val();

      input.bind('keyup change', function(){
        var term = (($(this).val() || '') + '').trim(),
            form = $(this).closest('form'),
            resultsList = form.find('.search-results');

        // If ajax-results container is not present, do nothing.
        if(!resultsList.length){ return; }

        if(term.length > 2) {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function(){
            // Abort any in-flight request
            if(abortController){ abortController.abort(); }
            abortController = new AbortController();

            // Simple in-memory cache to speed up backspacing / re-typing
if(cache.has(term)){
  resultsList.html(cache.get(term)).fadeIn();
  $('.s_suggestion').hide();
  return;
}

            try{
              var candidates = getSearchCandidates(term);
              var lastNoResultMarkup = '';

              function fetchCandidate(index){
                if(index >= candidates.length){
                  if(lastNoResultMarkup){
                    var cleanedNoResult = sanitizePredictiveMarkup(lastNoResultMarkup, term);
                    cache.set(term, cleanedNoResult);
                    resultsList.html(cleanedNoResult).fadeIn();
                    $('.s_suggestion').hide();
                  } else {
                    resultsList.empty().hide();
                    $('.s_suggestion').show();
                  }
                  return;
                }

                var candidate = candidates[index];
                var candidateCacheKey = 'predictive:' + candidate;

                function handleMarkup(resultsMarkup){
                  var cleanedMarkup = sanitizePredictiveMarkup(resultsMarkup, term);

                  if(hasPredictiveResults(cleanedMarkup)){
                    cache.set(term, cleanedMarkup);
                    cache.set(candidateCacheKey, cleanedMarkup);
                    resultsList.html(cleanedMarkup).fadeIn();
                    $('.s_suggestion').hide();
                  } else {
                    lastNoResultMarkup = resultsMarkup;
                    fetchCandidate(index + 1);
                  }
                }

                if(cache.has(candidateCacheKey)){
                  handleMarkup(cache.get(candidateCacheKey));
                  return;
                }

                var url = new URL(routes.predictive_search_url, window.location.origin);
                url.searchParams.set('q', index === 0 ? metPrefixSter(candidate) : candidate);
                url.searchParams.set('section_id', 'predictive-search');
                url.searchParams.set('resources[type]', 'product,collection,page,article,query');
                url.searchParams.set('resources[limit]', '12');
                url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,variants.sku,variants.barcode,vendor,tag,body');

                if(typeof slpr !== 'undefined' && slpr !== null && slpr !== ''){
                  url.searchParams.set('resources[options][unavailable_products]', slpr);
                }

                fetch(url.toString(), { signal: abortController.signal })
                  .then(function(response){
                    if(!response.ok){
                      throw new Error(response.status);
                    }
                    return response.text();
                  })
                  .then(function(text){
                    var doc = new DOMParser().parseFromString(text, 'text/html');
                    var sectionEl = doc.querySelector('#shopify-section-predictive-search');
                    var resultsMarkup = sectionEl ? sectionEl.innerHTML : '';

                    cache.set(candidateCacheKey, resultsMarkup);
                    handleMarkup(resultsMarkup);
                  })
                  .catch(function(error){
                    if(error && error.name === 'AbortError'){ return; }
                    fetchCandidate(index + 1);
                  });
              }

              fetchCandidate(0);
            } catch(e){
              resultsList.hide();
              $('.s_suggestion').fadeIn();
            }
          }, 250);
        } else {
          resultsList.empty().hide();
          $('.s_suggestion').show();
        }
      });
    });

    $('.modalOverly, .closeSearch').bind('click', function(){
      $('body').removeClass("showOverly");
      $('#searchPopup').removeClass("active");
    });
    $('.searchIco').on('click', function(e){
      e.preventDefault();
      $('body').addClass("showOverly");
      $('#searchPopup').addClass("active");
      $('input[name=q]').focus();
    });
  }
    return { init:init };
})();;
/*================ SECTIONS ================*/
window.theme = window.theme || {};
theme.HeaderSection = (function(){
  function Header() {
    theme.Header.init();
    theme.Search.init();
  }
  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function(){
      theme.Header.unload();
    }
  });
  return Header;
})();



/* eslint-disable no-new */
theme.Product = (function(){
  function Product(container) {
    this.container = container;
    var $container = this.$container = $(container),
    	sectionId = $container.attr('data-section-id');

    this.settings = {
      mediaQueryMediumUp: 'screen and (min-width: 768px)',
      mediaQuerySmall: 'screen and (max-width: 767px)',
      bpSmall: false,
      zoomEnabled: false
    };
    this.selectors={
      ftImg: '.featImg' + sectionId,
      imgWrap: '.pr_zoom_' + sectionId
    }
      
    if(!customElements.get('media-gallery')){
        customElements.define('media-gallery', class MediaGallery extends HTMLElement {
            constructor(){
                super();
            }
            connectedCallback(){
                var secId = this.dataset.section,
                    $carouselNavH = $('.ptw'+secId),
                    $carouselNav = $('.pr_thumbs' + secId),
                    $carouselNavCells = $carouselNav.find('.pr_thumbs_item'),
                    flkty = $('#pis'+secId).data('flickity'),
                    navTop  = $carouselNav.position().top,
                    navLeft  = $carouselNav.position().left,
                    navCellHeight = $carouselNavCells.height(),
                    navCellWidth = $carouselNavCells.width(),
                    navHeight = $carouselNav.height(),
                    navWidth = $carouselNav.width();
                $('#pis'+secId).on( 'select.flickity',function(){
                  $carouselNav.find('.active-thumb').removeClass('active-thumb');
                  var $selected = $carouselNavCells.eq(flkty.selectedIndex).addClass('active-thumb');
                  if($('.thumbs_nav.bottom').length || $(window).width()<767){
                    var scrollX = $selected.position().left + $carouselNavH.scrollLeft() - ( navWidth + navCellWidth) / 2.5;
                    $carouselNavH.animate({scrollLeft: scrollX});
                  } else {
                    var scrollY = $selected.position().top + $carouselNav.scrollTop() - ( navHeight + navCellHeight) / 2.5;
                    $carouselNav.animate({scrollTop: scrollY});
                  }
                });

                var $primgsl = $('#pis'+secId);
                $('.thumbs_nav .previous').on('click', function(){
                    $primgsl.flickity('previous');
                });
                $('.thumbs_nav .next').on('click', function(){
                    $primgsl.flickity('next');
                });

               $(window).on('load', function(e){
                $primgsl.flickity('resize');
                $('.pr_thumb[data-slide="0"] .prvideo').trigger('click');
                 var video = $('.primgSlider .videoSlide.is-selected video').get(0);
                if($(video).length){ video.play(); }
               });

               $primgsl.on('change.flickity', function(event, index){
                 if($(this).find('.videoSlide video').length){ $(this).find('.videoSlide video').get(0).pause(); }
                 var video = $(this).find('.videoSlide.is-selected video').get(0);
                 if($(video).length){ video.play(); }
                 var flkty = $(this).data('flickity');
                 if($(this).find('.is-selected model-viewer').length){
                    flkty.options.draggable = false;
                    flkty.updateDraggable();
                    $('.is-selected .shopify-model-viewer-ui__button--poster').trigger('click')
                 } else {
                    flkty.options.draggable = true;
                    flkty.updateDraggable();
                 }
               });
               let thumb = this.querySelectorAll(".pr_thumb");
                thumb.forEach((thumb)=>{
                 thumb.addEventListener('click',(e)=>{
                     e.preventDefault();
                     this.setActiveMedia(thumb.dataset.target);
                 });
                });
                
                this.setActiveMedia(this.dataset.target);
            }
            setActiveMedia(mediaId){
                var breakpoint = window.matchMedia('(min-width: 768px)'),
                    $primgsl = '#pis'+this.dataset.section;

                const activeMedia = $('.pr_photo[data-id="'+mediaId+'"]').index();
                if(activeMedia != undefined){
                    if(theme.productStrings.prStyle == "3" || theme.productStrings.prStyle == "4" || theme.productStrings.prStyle == "5" ){
                        var imgposition = $('.pr_photo[data-id="'+mediaId+'"]').offset();
                        if($(window).width()>767){
                            $("html, body").animate({ scrollTop: imgposition.top-70 }, 700);
                        } else {
                            $($primgsl).flickity('select', activeMedia);
                        }
                    } else {
                        $($primgsl).flickity('select', activeMedia);
                    }
                }
            }
            
        });
    }
    
    // change variant on image sections
    if(typeof vimgs !== 'undefined'){
      $('.pr_thumb').bind('click', function(e){
            e.preventDefault();
            var mid = $(this).attr('id');
            if(typeof vimgs[mid] !== 'undefined'){
                productOptions.forEach(function (value, i){
                 optionValue = vimgs[mid]['option-'+i];
                  if($('.swatch.pvOpt0').length){
                    if(optionValue !== null && $('.pvOpt'+i+' .swatchInput').filter(function(){ return $(this).val() === optionValue }).length){
                       $(".pvOpt"+i).find('.swatchInput[value="'+optionValue+'"]').trigger('click');
                     }
                  } else {
                    if(optionValue !== null && $('.single-option-selector:eq('+i+') option').filter(function(){ return $(this).text() === optionValue }).length){
                       $('.single-option-selector:eq('+i+')').val(optionValue).trigger('change');
                     }
                  }
              });
            }
      });
    }

    $(".product-info .review").on('click',function(e){
        $(".product-tabs li").removeClass("active");
      	$(".tablink[href='#ptabReview']").parent().addClass("active");
        $(".tab-content").not("#ptabReview").css("display", "none");
        $("#ptabReview").fadeIn();
      	var tabposition = $('#ptabReview').offset();
      	if($(window).width()<767) {
          $("html, body").animate({ scrollTop: tabposition.top-100 }, 700);
        } else{
          $("html, body").animate({ scrollTop: tabposition.top-150 }, 700);
        }
    });

    this.settings.zoomEnabled = $(this.selectors.ftImg).hasClass('js-zoom-enabled');
    this._initBreakpoints();
    this._stringOverrides();
  }

  Product.prototype = _.assignIn({},Product.prototype,{
    _stringOverrides: function(){
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function(){
      var self = this;
      enquire.register(this.settings.mediaQuerySmall, {
        match: function(){
          // destroy image zooming if enabled
          if(self.settings.zoomEnabled) {
            _destroyZoom($(self.selectors.productImageWrap));
          }
          self.settings.bpSmall = true;
        },
        unmatch: function(){
          self.settings.bpSmall = false;
        }
      });
      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function(){
          if(self.settings.zoomEnabled) {
            _enableZoom($(self.selectors.imgWrap));
          }
        }
      });
    },

    onUnload: function(){
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom($el){
    $($el).hover(
      function(){
        var zoomUrl = $(this).data('zoom');
        $(this).zoom({url: zoomUrl});
      }, function(){
        $(this).trigger('zoom.destroy');
      }
    );
  }

  function _destroyZoom($el){
    $($el).each(function(){
    	$(this).trigger('zoom.destroy');
     });
  }
  return Product;
})();

theme.tabs = (function(){
  function tabs(container){
    var $container = this.$container = $(container),
        sectionId = $container.attr('data-section-id'),
        tabs = this.tabs = '.product-tabs .tablink';

    $(tabs).on('click', function(e){
      e.preventDefault();
        $(this).parent().addClass("active").siblings().removeClass("active");
        var tab = $(this).attr("href");
        $(".tab-content").not(tab).css("display", "none");
        $(tab).fadeIn();
    });
    $('.acor-ttl .tablink').on('click', function(e){
      e.preventDefault();
        $(this).parent().toggleClass("active").next().slideToggle();
      	if($(window).width()<767) {
          var tabposition = $(this).offset();
          $("html, body").animate({ scrollTop: tabposition.top - 80 }, 500);
        }
    });
    $('.product-tabs li:first-child,.tab-container h3:first-child').addClass("active");
	$('.tab-container h3:first-child + .tab-content').show();
  }
  return tabs;
})();

// Product quick view
theme.QuickView = (function(){
  $('body').on( 'click', '.quick-view', function(e){
    $.ajax({
      beforeSend : function (){
        $('body').addClass("loading");
       },
      url: $(this).data('quick-url') || $(this).attr('href'),
      success: function(data) {

        $.magnificPopup.open({
          items: {
            src: '<div class="quick-view-popup mfpbox mfp-with-anim" id="content_quickview">' + data + '</div>',
            type: 'inline'
          },
          removalDelay:500,
          callbacks: {
            beforeOpen: function(){
             $('.stickyHeader').addClass('popup');
              this.st.mainClass = 'mfp-zoom-in';
            },
            open: function(){              
              	shopreviews();
            },
            close: function(){
               $('.stickyHeader').removeClass('popup');
              $( '#content_quickview' ).empty();
            }
          },
        });
      },
      complete: function(){
        $('body').removeClass("loading");
      }
    })
    e.preventDefault();
    e.stopPropagation();
  });
})();

theme.quotesl={};
theme.Quotes = (function(){
  function Quotes(container){
    var $container = this.$container = $(container),
        sectionId = $container.attr('data-section-id'),
        slider = this.quotesl = '#Quotes-' + sectionId;
    if(Shopify.designMode){
        var flktyData = $(slider).attr('data-flickity');
        if(slider.length){
            $(slider).flickity(JSON.parse(flktyData));
            setTimeout( function(){ $(slider).flickity('resize')});
        }
    }
      
  }
  return Quotes;
})();

theme.slideshows={};
theme.SlideshowSection = (function(){
  function SlideshowSection(container){
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#ss' + sectionId;
    $(slideshow).flickity();
    
    var iframes = $(slideshow).find('.embed-player');
    resizePlayer(iframes, 16/9, $(slideshow));
    $(window).on("resize", function(){
      resizePlayer(iframes, 16/9, $(slideshow));
    });
  }
    // Resize player
    function resizePlayer(iframes, ratio, slideshow){
      if(!iframes[0]) return;
      var win = $(slideshow),
          width = win.width(),
          playerWidth,
          height = win.height(),
          playerHeight,
          ratio = ratio || 16/9;

      iframes.each(function(){
        var current = $(this);
        if(width / ratio < height){
          playerWidth = Math.ceil(height * ratio);
          current.width(playerWidth).height(height).css({
            left: (width - playerWidth) / 2,
             top: 0
            });
        } else {
          playerHeight = Math.ceil(width / ratio);
          current.width(width).height(playerHeight).css({
            left: 0,
            top: (height - playerHeight) / 2
          });
        }
      });
    }
    
  return SlideshowSection;
})();

// CATEGORY SLIDER
theme.collectionView = (function(){
  function collectionView(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id'),
    	sliderSecond = $container.attr('data-section-timeout');
    
    $(document).on('change','#SortBySt',function(e){
		var value = $(this).val();
      	if($("#CollectionFiltersForm").length){
			$("#SortBy").val(value).trigger('change');
        } else {
          if(value.length) {
            window.location.search = 'sort_by='+value;
          } else {
            window.location.href = window.location.href.replace(window.location.search, '');
          }
        }
	});
    
	$(document).on('click', '.change-view', function(e){
      var view = $(this).data('view'),
          currentUrl = document.URL,
          url = new URL(currentUrl);
      url.searchParams.set("type", view); // setting your param
      window.location = url.href;
    });
    $(document).on('change', '.optTag', function(e){
  if ($("#CollectionFiltersForm").length) {
    return;
  }

  var URL = $('.sidebar_tags').data('url'),
      paramString = window.location.search.substring(1),
      productFilters = $('input.optTag'),
      newTags = [];

  productFilters.each(function(){
    if($(this).val() && $(this).is(":checked") === true) {
      newTags.push($(this).val());
    }
  });

  if(newTags.length){
    var tags = newTags.join('+');
    ajaxfilter(URL + '/' + tags + '?' + paramString);
  } else {
    ajaxfilter(URL + '?' + paramString);
  }
});
    $(document).on('change', '.flForm .custCheck, .flForm .custcheck, .flForm input[type="checkbox"][name^="filter."], .prRange, #SortBy', function(e){
      var URL =  '//'+window.location.hostname+window.location.pathname;
      // Force price filter minimum to €10 (UI and query) to avoid sample prices skewing results
      var $minPrice = $('input[name="filter.v.price.gte"]');
      if($minPrice.length){
        var mp = parseFloat(($minPrice.val()||'').toString().replace(',','.'));
        if(!isFinite(mp) || mp < 10){
          $minPrice.val(10);
        }
      }
      var formdata = $('#CollectionFiltersForm').serialize();
      //window.location.replace(URL+'?'+formdata);
      ajaxfilter(URL+'?'+formdata);
	});
  	
    // v11: delegated collapse/expand for filter boxes (survives ajaxfilter DOM replacement)
    $(document).on('click', '.sidebar_widget.filterBox .widget-title', function(e){
      // don't toggle when clicking inside a link/button inside the title
      if($(e.target).closest('a,button,select,input,label').length) return;
      var $box = $(this).closest('.sidebar_widget.filterBox');
      var $dd = $box.children('.filterDD');
      if(!$dd.length){
        // fallback for older markup
        $dd = $box.find('> .widget-content, > ul.widget-content, > ul.clrFl').first();
      }
      if(!$dd.length) return;
      $dd.toggleClass('hide');
      var $caret = $(this).find('.flt-caret');
      if($caret.length){
        var isOpen = !$dd.hasClass('hide');
        $caret.css({'transition':'transform 150ms ease','transform': isOpen ? 'rotate(180deg)' : 'rotate(0deg)'});
      }
    });
$(document).on('click', 'a.actFilter', function(e){
      e.preventDefault();
      var URL =  '//'+window.location.hostname+$(this).attr('href');
      ajaxfilter(URL);
	});
    $(document).on('click', 'span.actFilter', function(){
      var filter = $(this).attr("data-value");
      $(".filterBox input[value='"+filter+"']").trigger("click");
	});
    $('.flbytags').each(function(){
		var filter = $(this).find("li");
        if(filter.length <= 0){$(this).hide()}
	});
  
  	ajaxfilter = (function(url){
        $.ajax({
          type: 'GET',
          url: url,
          data:{},
          beforeSend:function(){
            $('body').addClass('loading hideOverly');
          },
          complete: function(data){
            $('.productList .grid-products').html($(".productList .grid-products", data.responseText).html());
            $('.filters-toolbar__product-count').html($(".filters-toolbar__product-count", data.responseText).html());
            
           	$('.sidebar_tags').html($(".sidebar_tags", data.responseText).html());
            $('.active-facets').html($(".active-facets", data.responseText).html());

            $('.pagination').html($(".pagination", data.responseText).html());
            if(!$(".pagination", data.responseText).html()){
              $('.pagination').hide();
            } else {
              $('.pagination').show();
            }
            $('.infinitpaginOuter').html($(".infinitpaginOuter", data.responseText).html());
            if(!$(".infinitpaginOuter", data.responseText).html()){
              $('.infinitpagin').remove();
            }
            if(theme.mlcurrency){ currenciesChange("sapn.money"); }
            $('body').removeClass('loading hideOverly');
            if($('.infinitpagin a.infinite').length){infiniteScroll();}
            loadMoreBtn();theme.countdown();shopreviews();

            if($('.prRange').length && typeof priceSlider === 'function'){ priceSlider(); }
            if($('#sideProdSlider').length){ $("#sideProdSlider").flickity(); }

            history.pushState({page: url}, url, url);
          }
        });
    });

    infiniteScroll = function(){
      	var action = 'scroll load';
        $(window).on(action, function(){
          var moreURL = $('.infinitpagin a').attr('href');
          if($('.infinitpagin a.infinite').length){
            var bottom = $('.infinitpagin').offset();
            var docTop = ($(document).scrollTop() + $(window).height() - 50);
            if( docTop > bottom.top){
              $(window).off(action);
              loadMore(moreURL);
            }
          }
        });
    }
    loadMoreBtn = function(){
        $(document).on('click', '.infinitpagin a.loadMore', function(e){
          	e.preventDefault();
          	var moreURL = $(this).attr('href');
			loadMore(moreURL);
        });
    }
    
    loadMore = function(moreURL) {
      if(moreURL.length){
        $.ajax({
          type: 'GET',
          dataType: 'html',
          url: moreURL,
          beforeSend:function(){
          	if($('.infinitpaginOuter').attr('data-type') == "button" ){
            	$('body').addClass('loading hideOverly');
            } else {
              $('.infinitpagin a').show();
            }
          },
          complete: function (data) {
            if($('.productList .grid-products').length){
            	$('.productList .grid-products').append($(".productList .grid-products", data.responseText).html());
            } else {
              	$('.productList .list-view-items').append($(".productList .list-view-items", data.responseText).html());
            }
            if($(".infinitpagin", data.responseText).html()){
            	$('.infinitpagin').html($(".infinitpagin", data.responseText).html());
            } else {
            	$('.infinitpagin').remove();
            }
			if(theme.mlcurrency){ currenciesChange("sapn.money"); }
            if($('.infinitpagin a.infinite').length){
              infiniteScroll();
            }
            theme.countdown();shopreviews();
            $('body').removeClass('loading hideOverly');
          }
        });
      }
    }
    
    $(document).ready(function(){
      infiniteScroll();loadMoreBtn();
    });
  }
  return collectionView;
})();

theme.instagramSection = (function(){
  function instagramSection(container) {
    var $container = this.$container = $(container),
    	sectionId = $container.attr('data-section-id'),
        act = $container.attr('data-act'),
        limit = $container.attr('data-count');
    
    $.ajax({
		url: 'https://graph.instagram.com/me/media?fields=id,media_type,media_url,permalink,thumbnail_url,caption,children&access_token='+act,
        type: 'GET',
        dataType: "json",
        success: function (res) {
        	var data = res.data,
				igdiv = '#instafeed'+sectionId,
               	html = '',
                bl = bl || true;
			$.each(data, function(index, el){
               if(index >= limit) return 0;
               var img_url = el.thumbnail_url || el.media_url;
               html += '<div class="gitem insta-img"><a rel="nofollow" class="instagram-" href="'+el.permalink+'" target="_blank"><img data-src="' + img_url + '" alt="" class="imgFt lazyload" /></a></div>';
            });
            $(igdiv).html(html);
            if($("#instafeed"+sectionId+".carousel").length){
                var option = $("#instafeed"+sectionId+".carousel").attr("data-flickity1") || '{}';
                var flkty = new Flickity("#instafeed"+sectionId+".carousel",JSON.parse(option));
            }
		}
	});
  }
  return instagramSection;
})();

theme.slcarousel={};
theme.carousel = (function(){
    function carousel(container) {
    	var $container = this.$container = $(container),
          sectionId = $container.attr('data-section-id'),
          carousel = this.slcarousel = $($container).find('.carousel'),
    	  tabs = this.tabs = '#' + sectionId + ' .tablink',
    	  tabcontent = this.tabcontent = '#' + sectionId + ' .tab-content';
    
    if(Shopify.designMode){
        var flktyData = this.slcarousel.attr('data-flickity');
        if(this.slcarousel.length){
            this.slcarousel.flickity(JSON.parse(flktyData));
            setTimeout( function(){ $('.carousel').flickity('resize')});
        }
    }
    $(tabs).on('click', function(e){
        e.preventDefault();
        $(this).parent().addClass("active").siblings().removeClass("active");
        var tab = $(this).attr("href");
        $(tabcontent).not(tab).css("display", "none");
        $(tab).fadeIn().find('.carousel').flickity('resize');
    });
  }
  return carousel;
})();

theme.masonary = (function(){
    function masonary(container){
    	var $container = this.$container = $(container),
          sectionId = $container.attr('data-section-id'),
          masonary = this.masonary = $($container).find('.grid-masonary');
    
      loadMasonary(masonary);
      setTimeout( function(){ loadMasonary(masonary); },1000);
      function loadMasonary(masonary) {
        $(masonary).masonry({
            columnWidth: '.grid-sizer-'+sectionId,
            itemSelector: '.ms-item',
            percentPosition: true
        });
      }
  }
  return masonary;
})();

if(!customElements.get('before-after')){
    customElements.define('before-after', class BeforeAfter extends HTMLElement {
        constructor(){
            super();
            const imageComparisonSlider = this
            this.init(imageComparisonSlider);
        }
   
        setSliderstate(e, element) {
          const sliderRange = document.querySelector('[data-image-comparison-range]');
          if (e.type === 'input') {
            sliderRange.classList.add('comparison-active');
            return;
          }
          sliderRange.classList.remove('comparison-active');
          element.removeEventListener('mousemove', this.moveSliderThumb);
        }

        moveSliderThumb(e) {
          const sliderRange = document.querySelector('[data-image-comparison-range]');
          const thumb = document.querySelector('[data-image-comparison-thumb]');
          let position = e.layerY - 20;

          if (e.layerY <= sliderRange.offsetTop) {
            position = -20;
          }
          if (e.layerY >= sliderRange.offsetHeight) {
            position = sliderRange.offsetHeight - 20;
          }
          thumb.style.top = `${position}px`;
        }

        moveSliderRange(e, element) {
          const value = e.target.value;
          const slider = element.querySelector('[data-image-comparison-slider]');
          const imageWrapperOverlay = element.querySelector('[data-image-comparison-overlay]');

          slider.style.left = `${value}%`;
          imageWrapperOverlay.style.width = `${value}%`;

          element.addEventListener('mousemove', this.moveSliderThumb);
          this.setSliderstate(e, element);
        }

        init(element){
          const sliderRange = element.querySelector('[data-image-comparison-range]');
          if ('ontouchstart' in window === false) {
            sliderRange.addEventListener('mouseup', e => this.setSliderstate(e, element));
            sliderRange.addEventListener('mousedown', this.moveSliderThumb);
          }

          sliderRange.addEventListener('input', e => this.moveSliderRange(e, element));
          sliderRange.addEventListener('change', e => this.moveSliderRange(e, element));
        }
    });
}

theme.ajaxCart = function(){

	$(".continue-shopping, .modalOverly, .closeDrawer").click(function(){
        $(".modal").fadeOut(200);
    	$("body").removeClass("loading showOverly");
    });
    
    $(document).on('click','.add-to-cart', function(e){
        e.preventDefault();
        $('body').addClass('loading');
        $(this).next().find('.cartBtn').trigger('click');
    });
    $(document).on('click','.mbCart', function(e){
        e.preventDefault();
        $('body').addClass('overflow-hidden').find('.ctdrawer').addClass('active');
    });
    
      $(document).on('click touch', '.quickShop', function(e){
          e.preventDefault(); e.stopImmediatePropagation();
          var url = $(this).attr('href'),
              imgwrapper = $(this).parents('.grid-view-item').find(".gview-img"),
              wrapper = $(this).parents(".grid-view-item").find('.shopWrapper');

          $.ajax({
            url: url+'/?section_id=quick-shop',
            dataType: 'html',
            type: 'GET',
            beforeSend:function(){
              $(imgwrapper).append("<i class='at at-spinner4 at-spin'></i>");
              $(imgwrapper).addClass('showLoading');
            },
            success: function(data){
              $(".shopWrapper").removeClass('active').html("");
              $(wrapper).addClass('active').html(data);
            },
            complete: function(data){
              $(imgwrapper).removeClass('showLoading');
              $(imgwrapper).find('.at-spinner4').remove();
              if(theme.mlcurrency){ currenciesChange(".shopWrapper.active .priceSingle span.money"); }
            }
          });
      });
      $(document).on('click touch', '.closeShop', function(e){
        e.preventDefault();
        $(this).parents(".shopWrapper").removeClass("active");
      });

        var cookieName = "wishlistList";
        function getWishlistItems(){
          var raw = '';
          try {
            raw = localStorage.getItem('wishlist') || '';
          } catch (err) {
            raw = '';
          }

          var seen = {};
          return String(raw).split('+').map(function(item){
            return $.trim(item);
          }).filter(function(item){
            if(!item || seen[item]){ return false; }
            seen[item] = true;
            return true;
          });
        }

        function setWishlistItems(items){
          var normalized = [];
          var seen = {};

          (items || []).forEach(function(item){
            item = $.trim(item || '');
            if(!item || seen[item]){ return; }
            seen[item] = true;
            normalized.push(item);
          });

          try {
            if(normalized.length){
              localStorage.setItem('wishlist', '+' + normalized.join('+'));
            } else {
              localStorage.removeItem('wishlist');
            }
          } catch (err) {}

          return normalized;
        }

        function updateWishlist(){
          var items = getWishlistItems();

          $('.wishlist[rel]').each(function(){
            var $btn = $(this);
            var rel = $.trim(String($btn.attr('rel') || ''));
            var active = items.indexOf(rel) !== -1;

            if(active){
              $btn.removeClass('addto-wishlist');
              $btn.find('span, .msg, .tooltip-label').text(theme.wlAvailable);
              $btn.find('.at').removeClass('at-heart-l at-circle-notch-r at-spin').addClass('at-heart');
            } else {
              $btn.addClass('addto-wishlist');
              $btn.find('.at').removeClass('at-heart at-circle-notch-r at-spin').addClass('at-heart-l');
            }
          });

          if(items.length){
            $('.favCount').text(items.length).removeClass('hide');
          } else {
            $('.favCount').text('0').addClass('hide');
          }

          $(document).trigger('wishlist:updated', [items]);
        }

        window.updateWishlist = updateWishlist;
        window.getWishlistItems = getWishlistItems;
        window.setWishlistItems = setWishlistItems;

        $(document).on('click', '.addto-wishlist', function(e){
           e.preventDefault();
           var id = $.trim(String($(this).attr('rel') || ''));
           if(!id){ return; }

           var items = getWishlistItems();
           if(items.indexOf(id) === -1){
             items.push(id);
             setWishlistItems(items);
           }

           $(this).find(".at").removeClass('at-heart-l').addClass('at-circle-notch-r at-spin');
           setTimeout(function(){
             $('.wishlist[rel="'+id+'"]').removeClass('addto-wishlist').find('span, .msg, .tooltip-label').text(theme.wlAvailable);
             $('.wishlist[rel="'+id+'"] .at').removeClass('at-circle-notch-r at-spin at-heart-l').addClass('at-heart');
             updateWishlist();
           },150);
         });

        updateWishlist();

        window.addEventListener('storage', function(event){
          if(!event || event.key === 'wishlist'){
            updateWishlist();
          }
        });
};
window.addEventListener('DOMContentLoaded',function(){$(theme.ajaxCart);});

$(document).ready(function(){
  var sections = new theme.Sections();
  sections.register('header-section', theme.HeaderSection);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.collectionView);
  sections.register('productTabs', theme.tabs);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('carousel', theme.carousel);
  sections.register('quotes', theme.Quotes);
  sections.register('masonary', theme.masonary);
  sections.register('instagram', theme.instagramSection);
});

theme.countdown = function(){
    $(".saleTime, .atCounter").each(function(){
        var $this = $(this), date = $(this).data('date'), countDownDate = new Date(date).getTime();
        var x = setInterval(function(){
            var now = new Date().getTime(),	            
                distance = countDownDate - now,
                days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                seconds = Math.floor((distance % (1000 * 60)) / 1000);
            if(days > 99){
                days = ("00" + days).substr(-3);
            } else {
                days = ("00" + days).substr(-2);
            }
            hours = ("00" + hours).substr(-2);
            minutes = ("00" + minutes).substr(-2);
            seconds = ("00" + seconds).substr(-2);

            $($this).find(".days").html(days);
            $($this).find(".hours").html(hours);
            $($this).find(".minutes").html(minutes);
            $($this).find(".seconds").html(seconds);
            if(distance < 0){clearInterval(x); $($this).hide().parents('.timerl').hide(); }
        }, 1000);
      });
}

theme.init = function(){
  slate.rte.wrapTable();
  slate.rte.iframeReset();
  theme.countdown();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt){
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt){
    evt.preventDefault();
  });
};
$(theme.init);

$(document).ready(function(){
  "use strict";
/* === SW BUGFIX: ensure window.theme exists and countdown is defined (prevents 'theme.countdown is not a function') === */
window.theme = window.theme || {};
if (typeof window.theme.countdown !== 'function') {
  window.theme.countdown = function () { return null; };
}

/* === BUGFIX: ensure theme.countdown exists (prevents crashes when optional countdown feature is not loaded) === */
window.theme = window.theme || {};
if (typeof window.theme.countdown !== 'function') {
  window.theme.countdown = function () { return null; };
}

  
	$(document).on('click', '.currencyOpt', function(i){
      $('#CurrencySelector').val($(this).data('value'));
      $('#localization_form').submit();
    });
    $(document).on('click', '.clOtp', function(i){
      var form = $(this).parents('form');
      $(form).find('.slcrlg').val($(this).data('value'));
      $(form).submit();
    });
  
   // LOOKBOOK SHOP 
	$('.btn-shop').click(function(){
       $('.products .list-columns, .grid-lookbook').removeClass('active');
       $(this).next().addClass('active');
       $(this).parents('.grid-lookbook').addClass('active');
	});
	$('.btn-shop-close').click(function(){     
    	$(this).parent().removeClass('active');
	});

  	// PROMOTION HEADER show-hide
    if(getCookie('promotion') == 'true'){
    	$(".notification-bar").slideUp();
  	}
	$(".close-announcement").click(function(){
		$(".notification-bar").slideUp();
        setCookie('promotion','true',1);
	});
  
	// SHOW HIDE PRODUCT Filters
  	$(document).on('click touch', '.btn-filter, .closeFilter', function(){
    	$(".filterbar").toggleClass("active");
	});
	$("body").click(function(event ){
    	var $target = $(event.target);
    	if(!$target.parents().is(".sb_filter") && !$target.is(".sb_filter")&& !$target.is(".btn-filter")){
      		$(".sb_filter").removeClass("active");
    	}
	});
  
  // STICKY HEADER
  window.onscroll = function(){ scrollfunction() };
  function scrollfunction(){
	if(theme.fixedHeader){
		if($(window).scrollTop()>145) {     
            // Kevin 07-09-2026 (CLS): spacer = hoogte van de header VOOR het fixen (91px), niet de gekrompen
            // sticky-hoogte (77px) die $('#header').height() na addClass gaf -> pagina sprong 14px bij elke scroll.
            if(!$('#header').hasClass('stickyHeader')){
              var __swHdrH = $('#header').outerHeight();
              $('#header').addClass("stickyHeader animated fadeInDown");
              $('.stickySpace').css("min-height",__swHdrH);
            }
    	} else {
            $('#header').removeClass("stickyHeader fadeInDown");
          	$('.stickySpace').css("min-height",'');
        }
    }
    
    /// sticky cart
    var stickyCartht = $(".stickyCart").height(),
        mobileBar = $(".mbtlwraper").height();
    if($(window).scrollTop()>600 && $(".stickyCart").length){
        if(mobileBar != ''){
          $("body.template-product").css('padding-bottom',stickyCartht+mobileBar);
          $(".stickyCart").slideDown();
          $(".stickyCart").css('bottom',mobileBar);
        } else {
          $("body.template-product").css('padding-bottom',stickyCartht);
          $(".stickyCart").slideDown();
        }
    } else {
      	$("body.template-product").css('padding-bottom','0');
        $(".stickyCart").slideUp();
    }

    // SITE SCROLLER
    if($(window).scrollTop()>200){
      $("#site-scroll").fadeIn();
    } else {
      $("#site-scroll").fadeOut();
    }
  }
  
  $("#site-scroll").click(function(){
    $("html, body").animate({ scrollTop: 0 }, 1000);
    return false;
  }); 
  
   //Footer links for mobiles
  $(".footer-links .h4").click(function(){
    if($(window).width() < 750){
      $(this).toggleClass("active");
      $(this).next().slideToggle();
  	}
  });
  
  $(document).on('click', '.gridSwatches li:not(.noImg)', function(e){
      var $this = $(this),
          newImage = $(this).attr('rel'),
          gridWrapper = $(this).parents('.grid-view-item').find('.gimg-link');
      $(gridWrapper).find('.variantImg').css("background-image", "url('"+newImage+"')");
      var image = document.createElement('img');
          image.src = newImage;
          image.onload = function () {
              $(gridWrapper).addClass("showVariantImg");
              $this.siblings().removeClass("active");
              $this.addClass("active");
          };
      return false;
    });
    $(document).on('click', '.gridSwatches li.numb', function(e){
      $(this).parents('.gridSwatches').find('.hide').removeClass('hide');
      $(this).addClass('hide');
    });

    // Magnific Popup
    $('.mfp-link').magnificPopup({
      delegate: '.mfp',
  	  removalDelay: 300, 
      callbacks: {
        beforeOpen: function(){
          $('.stickyHeader').addClass('popup');
           this.st.mainClass = this.st.el.attr('data-effect');
        },       
      	close:function(){ $('.stickyHeader').removeClass('popup'); }
      },
  	 midClick: true 
	});
});

function htmlDecode(input){
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
}
document.querySelectorAll('.mtmltxt').forEach(function(item){
    item.innerHTML = htmlDecode(item.innerHTML);
});





class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', false);
      this.setUnavailable();
    } else {
      this.toggleAddButton(false, '', false);
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
          return this.options[index] === option;
      }).includes(false);
    });
  }
  
  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;
    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const selectedSwatchValue = this.querySelector(`[data-opt="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-opt="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia(){
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`),
          crmedia = $('.primgSlider .is-selected').data('id');
    if(crmedia != `media${this.currentVariant.featured_media.id}` || Shopify.designMode){
        mediaGalleries.forEach((mediaGallery) =>
          mediaGallery.setActiveMedia(`media${this.currentVariant.featured_media.id}`, true)
        );
    }
    
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  isVariantSelectable(variant) {
    if (!variant) return false;
    const managed = variant.inventory_management === 'shopify';
    const canContinue = variant.inventory_policy === 'continue';
    return variant.available !== false || !managed || canContinue;
  }

  updateVariantStatuses(){
    const inputWrappers = [...this.querySelectorAll('[data-option-index]')];
    const variants = this.getVariantData();

    if (!inputWrappers.length || !variants.length) return;

    const currentSelections = inputWrappers.map((option) => {
      const select = option.querySelector('select');
      if (select) return String(select.value || '');

      const checked = option.querySelector('input[type="radio"]:checked');
      return checked ? String(checked.value || '') : '';
    });

    const matchesPrefix = (variant, uptoIndex) => {
      for (let selectionIndex = 0; selectionIndex < uptoIndex; selectionIndex += 1) {
        const selectedValue = String(currentSelections[selectionIndex] || '');
        if (!selectedValue) continue;
        if (String(variant[`option${selectionIndex + 1}`] || '') !== selectedValue) return false;
      }
      return true;
    };

    inputWrappers.forEach((option, index) => {
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const availableOptionInputsValue = [];
      const seenValues = {};

      optionInputs.forEach((element) => {
        const value = String((element.value != null ? element.value : element.getAttribute('value')) || '');
        if (!value || seenValues[value]) return;
        seenValues[value] = true;

        const availableElement = variants.some((variant) => {
          if (String(variant[`option${index + 1}`] || '') !== value) return false;
          if (!this.isVariantSelectable(variant)) return false;
          return matchesPrefix(variant, index);
        });

        if (availableElement) {
          availableOptionInputsValue.push(value);
        }
      });

      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    const escapeValue = (value) => {
      value = String(value == null ? '' : value);
      if (window.CSS && window.CSS.escape) return window.CSS.escape(value);
      return value.replace(/([ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1');
    };

    elementList.forEach((element) => {
      const value = String((element.value != null ? element.value : element.getAttribute('value')) || '');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.disabled = !availableElement;
        element.classList.toggle('disabled', !availableElement);

        let target = null;
        if (element.id) {
          try {
            target = this.querySelector(`label[for="${escapeValue(element.id)}"]`);
          } catch (e) {}
        }

        if (!target) {
          target = element.closest('.swatch-element, .swatch, .variant-option, .vswatch, .opt-item, label') || element.parentElement;
        }

        if (target) {
          target.classList.toggle('disabled', !availableElement);
          target.setAttribute('data-swv-disabled', availableElement ? 'false' : 'true');
          if (availableElement) {
            target.removeAttribute('aria-disabled');
          } else {
            target.setAttribute('aria-disabled', 'true');
          }
        }
      } else if (element.tagName === 'OPTION') {
        element.disabled = !availableElement;
        element.classList.toggle('disabled', !availableElement);
      }
    });
  }


  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    if($('.stickyCart').length){
        $('.selectedOpt').html(this.currentVariant.title);
        if(this.currentVariant.featured_image != null){
            $('.stickCtImg').attr('src',this.currentVariant.featured_image.src+'&width=50');
        }
    }
    
    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const stockLabel = html.getElementById(`stockLabel-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const stockLabelDestination = document.getElementById(`stockLabel-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const volumePricingSource = html.getElementById(`Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (stockLabel && stockLabelDestination) stockLabelDestination.innerHTML = stockLabel.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination){
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if(price) price.classList.remove('hidden');
        
        
        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        // Determine orderability: allow backorders / unmanaged inventory as buyable
        const _v = this.currentVariant;
        const _managed = _v && _v.inventory_management === 'shopify';
        const _canContinue = _v && _v.inventory_policy === 'continue';
        const _orderable = !_v ? false : (_v.available !== false) || !_managed || _canContinue;
        this.toggleAddButton(addButtonUpdated ? (addButtonUpdated.hasAttribute('disabled') && !_orderable) : true, window.variantStrings.soldOut);
        
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = false, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if(disable){
      addButton.setAttribute('disabled', 'disabled');
      if(text) addButtonText.textContent = text;
      if($('.backStock').length) checkBackinstock(`${this.currentVariant.id}`);

    } else {
      const _v2 = this.currentVariant;
      // Update sample flag on form when variant changes
      const _form2 = document.getElementById(`product-form-${this.dataset.section}`);
      if(_form2 && _v2){
        try{
          const _vtJson = document.getElementById(`VariantTitles-${this.dataset.section}`);
          if(_vtJson){
            const _titles = JSON.parse('[' + _vtJson.textContent + ']');
            const _match = _titles.find(t => t.id == _v2.id);
            const _vTitle = _match ? _match.title.toLowerCase() : '';
            _form2.dataset.isSample = window.swIsSampleTitle(_vTitle) ? 'true' : 'false';
            window.swLockSampleQty(this.dataset.section, _form2.dataset.isSample === 'true');
          }
        }catch(e){}
      }
      // Kevin 15-10-2026: geen stalen naar het VK (window.swStaalUK alleen voor bezoekers in het VK, layout/theme.liquid)
      if(window.swStaalUK && _form2 && (_form2.dataset.isSample === 'true' || _form2.dataset.isSample === '1'
         || (_v2 && window.swStaalUK.kaart && window.swStaalUK.kaart.test(String(_v2.title || ''))))){
        addButton.setAttribute('disabled', 'disabled');
        addButton.setAttribute('data-staal-uk', 'true');
        addButtonText.textContent = window.swStaalUK.tekst;
        const dynUK = document.getElementById(`DynamicCheckout-${this.dataset.section}`);
        if(dynUK) dynUK.style.display = 'none';
        return;
      }
      addButton.removeAttribute('data-staal-uk');
      // Block €0 products: keep disabled, show "Price on request"
      if(_v2 && _v2.price === 0){
        addButton.setAttribute('disabled', 'disabled');
        addButton.setAttribute('data-price-zero', 'true');
        addButtonText.textContent = window.variantStrings.priceOnRequest || 'Price on request';
        // Hide dynamic checkout for €0
        const dynCheckout = document.getElementById(`DynamicCheckout-${this.dataset.section}`);
        if(dynCheckout) dynCheckout.style.display = 'none';
      } else {
        addButton.removeAttribute('disabled');
        addButton.removeAttribute('data-price-zero');
        var qty = $(`#pvr-${this.currentVariant.id}`).text();
        const _managed2 = _v2 && _v2.inventory_management == "shopify";
        // Pre-order: tracked by Shopify, qty < 1, but still available (inventory_policy continue)
        if(qty < 1 && _managed2 && _v2 && _v2.available){
          addButtonText.textContent = window.variantStrings.preOrder;
        } else {
          addButtonText.textContent = window.variantStrings.addToCart;
        }
        // Show dynamic checkout again if it was hidden
        const dynCheckout = document.getElementById(`DynamicCheckout-${this.dataset.section}`);
        if(dynCheckout) dynCheckout.style.display = '';
      }
      if($('.backStock').length)$('.backStock').addClass('hide');
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);



if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"], button[name="add"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    if (this.input) {
      this.input.addEventListener('change', this.onInputChange.bind(this));
    }
    this.querySelectorAll('.qtyBtn').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback(){
    if (!this.input) return;
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }
  disconnectedCallback(){
    if(this.quantityUpdateUnsubscriber){ this.quantityUpdateUnsubscriber(); }
  }
  onInputChange(event){ this.validateQtyRules(); }

  onButtonClick(event) {
    event.preventDefault();
    if (!this.input) return;
    const previousValue = this.input.value;
    const actionButton = event.currentTarget || event.target;
    const action = actionButton && actionButton.name ? actionButton.name : event.target.name;
    action === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if(previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    this.validateQtyRules();
  }

  validateQtyRules() {
    if (!this.input) return;
    const value = parseInt(this.input.value, 10);
    if(this.input.min) {
      const min = parseInt(this.input.min, 10);
      const buttonMinus = this.querySelector(".qtyBtn[name='minus']");
      if (buttonMinus && buttonMinus.classList) {
        buttonMinus.classList.toggle('disabled', Number.isFinite(value) ? value <= min : true);
      }
    }
    if(this.input.max) {
      const max = parseInt(this.input.max, 10);
      const buttonPlus = this.querySelector(".qtyBtn[name='plus']");
      if (buttonPlus && buttonPlus.classList) {
        buttonPlus.classList.toggle('disabled', Number.isFinite(value) ? value >= max : false);
      }
    }
  }
}
customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay){
  let lastCall = 0;
  return function (...args){
    const now = new Date().getTime();
    if(now - lastCall < delay){
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json'){
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if(elementToFocus) elementToFocus.focus();
}

var trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (e) => {
    if( e.target !== container && e.target !== last && e.target !== first )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function(){
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(e) {
    if(e.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if(e.target === last && !e.shiftKey) {
      e.preventDefault();
      first.focus();
    }
    //  On the first focusable element and tab backward, focus the last element.
    if((e.target === container || e.target === first) && e.shiftKey){
      e.preventDefault();
      last.focus();
    }
  };
  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  elementToFocus.focus();
  if(elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value){
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (e) => {
      e.preventDefault();
      var cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.addEventListener('change', debouncedOnChange.bind(this));
  }
  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if(event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if(this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(e){
    var stopTg = e.target.classList.contains('stopEv');
    if(!stopTg){
      this.updateQuantity(e.target.dataset.index, e.target.value, document.activeElement.getAttribute('name'), e.target.dataset.quantityVariantId);
    }
  }   
  onCartUpdate(){
    if(this.tagName === 'CART-DRAWER-ITEMS'){
      fetch(`${routes.cart_url}?section_id=cart-drawer`).then((response) => response.text()).then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if(targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        }).catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`).then((response) => response.text()).then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        }).catch((e) => {
          console.error(e);
        });
    }
  }
    
  getSectionsToRender(){
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.cartTotal',
      }
    ];
  }

  updateQuantity(line, quantity, name, variantId){
      this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } }).then((response) => {
        return response.text();
      }).then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if(parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if(cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if(cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if(items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if(typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if(lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if(parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if(document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if(lineItemError) lineItemError.querySelector('.ctItem-error').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
    freeShippMsg();

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }
  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}
customElements.define('cart-items', CartItems);

if(!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', debounce((e) => {
        var body = JSON.stringify({ note: e.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    var cartLink = document.querySelector('#cartLink');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (e) => {
      e.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (e) => {
      if(e.code.toUpperCase() === 'SPACE') {
        e.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if(triggeredBy) this.setActiveElement(triggeredBy);
    var cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if(cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('active')});

    this.addEventListener('transitionend', () => {
      var containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      var focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    document.body.classList.remove('loading');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (e) => {
      e.currentTarget.setAttribute('aria-expanded', !e.currentTarget.closest('details').hasAttribute('open'));
    });

    //cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      var sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }
  getSectionInnerHTML(html, selector = '.shopify-section'){
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      }
    ];
  }
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      }
    ];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if(localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`).then((response) => response.text()).then((responseText) =>{

      });
      if(document.querySelector('#cartCoupon')){
        document.querySelector('#cartCoupon').classList.remove("active");
      }
    })
  }
}
customElements.define('coupon-code', CouponCode);

class CartOption extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('.cftBtn').forEach((button) => button.addEventListener("click", function(e){
        e.preventDefault()
        var ftbk = this.hash.substr(1);
        $('.cftDraw.active').removeClass('active');
        document.getElementById(ftbk).classList.add("active");
    }));
    document.querySelectorAll('.saveBtn').forEach((button) => button.addEventListener("click", function(e){
        var box = document.querySelectorAll('.cftDraw');
        box.forEach(box => { box.classList.remove("active"); });
    }));
  }
}
customElements.define('cart-option', CartOption);

function startTimer(duration, display){
    var timer = duration, minutes, seconds;
    setInterval(function(){
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        display.textContent = minutes + ":" + seconds;

        if(--timer < 0){
            clearInterval(startTimer);
            document.querySelector('.cartCountdown').remove();
        }
    }, 1000);
}
window.onload = function(){
    if(document.querySelector('.cartCountdown')){
        var countdownEl = document.querySelector('.cartCountdown');
        var display = document.querySelector('#cartTime');
        if(countdownEl && display){
            var minutes = countdownEl.getAttribute('data-countdown');
            startTimer(minutes, display);
        }
}
};

if(!customElements.get('product-form')){
  customElements.define('product-form',class ProductForm extends HTMLElement{
      constructor() {
        super();
        this.form = this.querySelector('form');
        if(!this.form) return;
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        // SW 10-09-2026: staal al gekozen bij openen (geen variantwissel) -> aantal meteen vergrendelen
        try{ if(this._swIsSampleForm()) window.swLockSampleQty(this.dataset.sectionId, true); }catch(e){}
        this.submitButton = this.querySelector('[type="submit"], button[name="add"]');

        if(document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt){
        evt.preventDefault();
        // Null-guard: op price-on-request-producten stond de knop op type=button
        // bij element-init, waardoor submitButton null was en elke sample-klik
        // hier stil crashte (Abaca Mist-bug 20-08).
        if(!this.submitButton) this.submitButton = this.querySelector('[type="submit"], button[name="add"]');
        if(!this.submitButton) return;
        if(this.submitButton.getAttribute('aria-disabled') === 'true') return;
        // Block €0 products from being added to cart
        if(this.submitButton.hasAttribute('disabled') || this.submitButton.dataset.priceZero === 'true') return;
        // Kevin 15-10-2026: geen stalen naar het VK
        if(window.swStaalUK && this.form && (/^(true|1)$/.test(this.form.dataset.isSample || '') || this.form.dataset.staalUk === '1')) return;

        this.handleErrorMessage();

        // Sample duplicate guard: check if this sample variant is already in the cart
        const _isSample = this._swIsSampleForm();
        const _variantId = this.form.querySelector('[name="id"]')?.value;

        if(_isSample && _variantId){
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.btn_spinner').classList.remove('hidden');

          fetch(`${routes.cart_url}.js`, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
            .then(r => r.json())
            .then(cartData => {
              const alreadyInCart = cartData.items && cartData.items.some(item => String(item.variant_id) === String(_variantId));
              if(alreadyInCart){
                const _lang = (window.Shopify && Shopify.locale || document.documentElement.lang || 'nl').substring(0,2).toLowerCase();
                const _msgs = { nl: 'Dit sample zit al in je winkelwagen.', de: 'Dieses Muster befindet sich bereits in Ihrem Warenkorb.', en: 'This sample is already in your cart.' };
                this.handleErrorMessage(_msgs[_lang] || _msgs.en);
                this.submitButton.removeAttribute('aria-disabled');
                this.submitButton.classList.remove('loading');
                this.querySelector('.btn_spinner').classList.add('hidden');
                return;
              }
              this._doAddToCart();
            })
            .catch(() => { this._doAddToCart(); });
          return;
        }

        this._doAddToCart();
      }

      _doAddToCart(){
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.btn_spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // SW 10-09-2026: een staal gaat altijd als 1 de winkelwagen in, wat er ook in het aantal-veld staat; een rol/meter
        // nooit onder het productminimum (data-sw-min dragen alleen quick view en Snelwinkel; de productpagina regelt dit zelf)
        const _swSample = this._swIsSampleForm();
        const _swQ = document.getElementById(`Quantity-${this.dataset.sectionId}`) || this.form.querySelector('input[name="quantity"]');
        let _swQty = null;
        if(_swSample){ _swQty = '1'; }
        else if(_swQ && _swQ.getAttribute('data-sw-min')){
          const _swMin = Math.max(parseInt(_swQ.getAttribute('data-sw-min'), 10) || 1, parseInt(_swQ.min, 10) || 1, 1);
          _swQty = String(Math.max(parseInt(_swQ.value, 10) || 0, _swMin));
        }
        if(_swQ && _swQty !== null) _swQ.value = _swQty;
        const formData = new FormData(this.form);
        if(_swQty !== null) formData.set('quantity', _swQty);
        if(this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config).then((response) => response.json()).then((response) => {
            if(response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if(!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            // Server-side sample guard: after add, check cart for sample items with qty > 1 and correct them
            this._enforceSampleLimits();

            if(!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if(!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if(quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if(this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if(!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.btn_spinner').classList.add('hidden');
            freeShippMsg();
          });
      }

      handleErrorMessage(errorMessage = false) {
        if(this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if(!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if(errorMessage){ this.errorMessage.textContent = errorMessage; }
      }

      _swIsSampleForm(){
        // SW 10-09-2026: staal-status van dit formulier. Zonder variantwissel (staal vooraf gekozen) is dataset.isSample
        // nog leeg; dan kijken we zelf in VariantTitles-<section> (staat sinds vandaag ook in quick view en Snelwinkel).
        try{
          if(this.form.dataset.isSample === 'true') return true;
          if(this.form.dataset.isSample === 'false') return false;
          const _json = document.getElementById(`VariantTitles-${this.dataset.sectionId}`);
          const _id = this.form.querySelector('[name="id"]')?.value;
          if(_json && _id){
            const _t = JSON.parse('[' + _json.textContent + ']').find(v => String(v.id) === String(_id));
            return !!(_t && window.swIsSampleTitle(_t.title));
          }
        }catch(e){}
        return false;
      }

      _enforceSampleLimits(){
        const SAMPLE_MAX = 10;
        const isSample = (item) => {
          // Alleen de variant-titel, niet de producttitel: die bevat de dessin-
          // naam, en daar zitten namen als 'Monster Family Blanc' tussen.
          const props = item.properties || {};
          return (props._is_sample === '1' || props._is_sample === 1)
                 || window.swIsSampleTitle(item.variant_title || '');
        };
        fetch(`${routes.cart_url}.js`, { credentials:'same-origin', headers:{'Accept':'application/json'} })
          .then(r => r.json())
          .then(cart => {
            if(!cart || !cart.items) return;

            // Step 1: Force quantity = 1 on every sample line
            const qtyUpdates = {};
            cart.items.forEach(item => {
              if(isSample(item) && item.quantity > 1){
                qtyUpdates[item.key] = 1;
              }
            });

            // Step 2: If more than SAMPLE_MAX distinct sample lines exist, remove the excess
            // Keep the OLDEST sample lines (first added), remove the MOST RECENT extras.
            // Cart items are returned in add-order; later index = added later.
            const sampleKeys = cart.items.filter(isSample).map(i => i.key);
            let removeKeys = [];
            if (sampleKeys.length > SAMPLE_MAX){
              removeKeys = sampleKeys.slice(SAMPLE_MAX);
            }

            const promises = [];
            // Apply qty=1 fixes
            Object.entries(qtyUpdates).forEach(([key, qty]) => {
              promises.push(fetch(`${routes.cart_change_url}.js`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: key, quantity: qty })
              }));
            });
            // Apply removals (qty=0 removes the line)
            removeKeys.forEach(key => {
              promises.push(fetch(`${routes.cart_change_url}.js`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: key, quantity: 0 })
              }));
            });

            if (!promises.length) return;
            Promise.all(promises).then(() => {
              if (removeKeys.length){
                // Notify the user that excess samples were removed
                const lang = (document.documentElement.lang || 'nl').slice(0,2).toLowerCase();
                let msg;
                if (lang === 'de') msg = `Sie können maximal ${SAMPLE_MAX} Muster bestellen. ${removeKeys.length} überschüssige Muster wurden aus dem Warenkorb entfernt.`;
                else if (lang === 'en') msg = `You can order a maximum of ${SAMPLE_MAX} samples. ${removeKeys.length} extra sample(s) were removed from your cart.`;
                else msg = `Je kunt maximaal ${SAMPLE_MAX} samples bestellen. ${removeKeys.length} extra sample(s) zijn verwijderd uit je winkelwagen.`;
                try { alert(msg); } catch(e) {}
              }
              // Refresh cart UI
              try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch(e) {}
              try { if (window.publish && typeof window.publish === 'function') window.publish('cart-update'); } catch(e) {}
              // Reload cart drawer/page if visible
              try {
                if (window.location.pathname === routes.cart_url) location.reload();
              } catch(e) {}
            }).catch(() => {});
          })
          .catch(() => {});
      }
    }
  );
}
function freeShippMsg(){
    var countTargets = document.querySelectorAll('#CartCount, #CartCount span, [data-cart-count], .cart-count-bubble, .cart-count-bubble span[aria-hidden]');
    var freeshipTarget = document.querySelector('.freeShipMsg');

    if(!countTargets.length && !freeshipTarget) return;

    fetch(`${routes.cart_url}.js`, { headers: { 'Accept': 'application/json' } })
      .then((response) => {
        if(!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then((cart) => {
        if(!cart || typeof cart.item_count !== 'number') return;

        var seen = [];
        Array.prototype.forEach.call(countTargets, function(node){
          if(!node || seen.indexOf(node) !== -1) return;
          seen.push(node);

          var target = node;
          var inner = node.querySelector && node.querySelector('span[aria-hidden]');
          if(inner) target = inner;

          if(target && target.nodeType === 1){
            target.textContent = String(cart.item_count);
          }

          try { node.setAttribute && node.setAttribute('data-cart-count', String(cart.item_count)); } catch(e) {}
        });
      })
      .catch(() => {});

    if(!freeshipTarget) return;

    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => {
        if(!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((responseText) => {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        var shipsource = html.querySelector('.freeShipMsg');
        if(shipsource && freeshipTarget) freeshipTarget.innerHTML = shipsource.innerHTML;
        if(theme.mlcurrency){ currenciesChange(".freeShipMsg span.money"); }
      })
      .catch(() => {});
}
freeShippMsg();

class CartDiscount extends HTMLElement {
  #activeFetch = null;
  constructor() {
    super();
    const form = this.querySelector("form");
    form.addEventListener("submit", this.applyDiscount);

    this.addEventListener("click", (event) => {
      if (event.target.closest(".cart-discount-remove")) {
        this.removeDiscount(event);
      }
    });
    this.submitButton = this.querySelector('[type="submit"], button[name="add"]');
    this.errorEl = document.querySelector('.cart-discount__error') || document.querySelector('CartDrawer-discount__error');
  }

  #createAbortController() {
    if(this.#activeFetch) this.#activeFetch.abort();

    const abortController = new AbortController();
    this.#activeFetch = abortController;
    return abortController;
  }

  async #updateCartDiscount(discountCodes, abortController) {
    const body = JSON.stringify({discount: discountCodes.join(","), sections: this.getSectionsToRender().map((section) => section.section), sections_url: window.routes.cart_url,});
    console.log(body);
    const response = await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body: body, signal: abortController.signal } });
    return response.json();
  }

  #updateCartUI(data){
    // Update main cart sections
    this.getSectionsToRender().forEach((section) => {
      if (data.sections && data.sections[section.section]){
        const elementToReplace = document.getElementById(section.id) ?.querySelector(section.selector) || document.getElementById(section.id);
        if(elementToReplace){
          elementToReplace.innerHTML = this.getSectionInnerHTML(data.sections[section.section], section.selector);
        }
      }
    });
  }

  #setLoadingState(isLoading) {
    if (isLoading) {
      this.submitButton.setAttribute("aria-disabled", "true");
      this.submitButton.classList.add("loading");
      this.submitButton.querySelector('.loading__spinner').classList.remove("hidden");
    } else {
      this.submitButton.removeAttribute("aria-disabled");
      this.submitButton.classList.remove("loading");
      this.submitButton.querySelector('.loading__spinner').classList.add("hidden");
    }
  }

  /*** Returns an array of existing discount codes. * @returns {string[]} */
  #existingDiscounts() {
    const discountCodes = [];
    const discountPills = this.querySelectorAll(".discount-code, [data-discount-code]");

    for (const pill of discountPills){
      if (pill instanceof HTMLElement){
        const code = pill.dataset.discountCode || pill.dataset.code;
        if (typeof code === "string" && code.trim()) {
          discountCodes.push(code.trim());
        }
      }
    }
    return discountCodes;
  }
  applyDiscount = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    this.errorEl.classList.add('hidden');
    
    const form = event.target instanceof HTMLFormElement ? event.target : this.querySelector("form");
    const discountCode = form.querySelector('input[name="discount"]');
    const discountCodeValue = discountCode.value.trim();
    if(!discountCodeValue) return;

    // Check if discount already exists
    const existingDiscounts = this.#existingDiscounts();
    if (existingDiscounts.includes(discountCodeValue)){
      this.#handleDiscountError('exist');
      return;
    }

    this.#setLoadingState(true);
    const abortController = this.#createAbortController();

    try {
      const updatedDiscounts = [...existingDiscounts, discountCodeValue];
      const data = await this.#updateCartDiscount(updatedDiscounts, abortController);

      /** @type {{ code: string; applicable: boolean; }} */
      if(data.discount_codes.find((discount) => { return (discount.code === discountCodeValue && discount.applicable === false);})){
        this.#handleDiscountError('discount');
        return;
      }

      discountCode.value = "";
      this.#updateCartUI(data);
      //this.#checkShipCode(discountCodeValue,data.discount_codes);
    } catch (error) {
      var type = "applying discount"
      this.#handleDiscountError(type);
    } finally {
      this.#setLoadingState(false);
      this.#activeFetch = null;
    }
  };

  removeDiscount = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const removeButton = event.target.closest(".cart-discount-remove");
    removeButton.setAttribute("aria-disabled", "true");
    removeButton.classList.add("loading");
    if(event instanceof KeyboardEvent && event.key !== "Enter") return;

    const discountCode = this.#getDiscountCodeFromEvent(event);
    if(!discountCode) return;

    const existingDiscounts = this.#existingDiscounts();
    const updatedDiscounts = existingDiscounts.filter((code) => code !== discountCode);

    if(updatedDiscounts.length === existingDiscounts.length){
      console.warn("Discount code not found in existing discounts");
      return;
    }

    const abortController = this.#createAbortController();

    try {
      const data = await this.#updateCartDiscount(updatedDiscounts, abortController);
      this.#updateCartUI(data);
    } catch (error) {

    } finally {
      this.#activeFetch = null;
      removeButton.setAttribute("aria-disabled", "false");
      removeButton.classList.remove("loading");
      this.errorEl.classList.add('hidden');
    }
  };

  #getDiscountCodeFromEvent(event) {
    const removeButton = event.target.closest(".discount-code");
    if (!removeButton) return null;
    return (removeButton.dataset.code || removeButton.dataset.discountCode || removeButton.closest("[data-discount-code]")?.dataset.discountCode || null);
  }

  #checkShipCode(code, codes){
    const existingDiscounts = this.#existingDiscounts();
    if(!existingDiscounts.includes(code) && codes.find((discount) => { return (discount.code === code && discount.applicable === true);})){
      this.#handleDiscountError('shipping');
    }
  }
  /*** Handles the discount error. */
  #handleDiscountError(type){
    if(type == 'shipping'){
      this.errorEl.textContent = cartStrings?.discount_ship;
    } else if(type == 'exist'){
      this.errorEl.textContent = cartStrings?.discount_already;
    } else {
      this.errorEl.textContent = cartStrings?.discount_error;
    }
    this.errorEl.classList.remove('hidden');
  }

  getSectionsToRender(){
    const mainCartItems = document.getElementById("main-cart-items");
    if(mainCartItems){
        return [
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items').dataset.id,
            selector: '.js-contents',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section'
          },
          {
            id: 'main-cart-footer',
            section: document.getElementById('main-cart-footer').dataset.id,
            selector: '.cartTotal',
          },
          {
            id: 'cartDiscount',
            section: document.getElementById('cartDiscount').dataset.id,
            selector: '.cart-discount__codes',
          }
        ];
    } else {
       return [
          {
            id: 'CartDrawer',
            section: 'cart-drawer',
            selector: '.drawer__inner'
          },
          {
            id: 'cartDiscount',
            section: document.getElementById('cartDiscount').dataset.id,
            selector: '.cart-discount__codes',
          }
        ];
    }
  }

  getSectionInnerHTML(html, selector) {
    return ( new DOMParser().parseFromString(html, "text/html").querySelector(selector)?.innerHTML || "" );
  }
}

if (!customElements.get("cart-discount")){
  customElements.define("cart-discount", CartDiscount);
}
function shopreviews(){
    
}



/* ==== KLEUR: localize active chip labels + swap product tile to matching variant image (custom.kleur) ==== */
(function(){
  function _getLocale(){
    var l = (window.Shopify && Shopify.locale) || document.documentElement.getAttribute('lang') || '';
    l = (l || '').toLowerCase();
    if(l.indexOf('-')>-1) l = l.split('-')[0];
    return l || 'nl';
  }
  var _kleurLabels = {
    nl: { blauw:'Blauw', zwart:'Zwart', wit:'Wit', geel:'Geel', groen:'Groen', rood:'Rood', oranje:'Oranje', paars:'Paars', roze:'Roze', bruin:'Bruin', grijs:'Grijs', zilver:'Zilver', goud:'Goud', aqua:'Aqua', beige:'Beige', naturel:'Naturel' },
    en: { blauw:'Blue', zwart:'Black', wit:'White', geel:'Yellow', groen:'Green', rood:'Red', oranje:'Orange', paars:'Purple', roze:'Pink', bruin:'Brown', grijs:'Grey', zilver:'Silver', goud:'Gold', aqua:'Aqua', beige:'Beige', naturel:'Natural' },
    de: { blauw:'Blau', zwart:'Schwarz', wit:'Weiß', geel:'Gelb', groen:'Grün', rood:'Rot', oranje:'Orange', paars:'Violett', roze:'Rosa', bruin:'Braun', grijs:'Grau', zilver:'Silber', goud:'Gold', aqua:'Aqua', beige:'Beige', naturel:'Natürlich' }
  };
  function _canon(v){

    v = (v || '').toString();
    try { v = decodeURIComponent(v); } catch(e){}
    v = v.toLowerCase().trim();

    // Strip diacritics (e.g., Natuurlijk -> naturlich) and normalize German ß
    try { v = v.normalize('NFD').replace(/[\u0300-\u036f]/g,''); } catch(e){}
    v = v.replace(/ß/g,'ss');

    // Normalize spacing
    v = v.replace(/\s+/g,' ');

    // Naturel group: Naturel / Natural / Natürlich / Naturlich / Natuerlich / "Natural ..." etc.
    // We intentionally match on "natur" broadly, because stores often mix NL/EN/DE values in metafields.
    if(v.indexOf('naturel') > -1 || v.indexOf('natural') > -1 || v.indexOf('natur') > -1) return 'naturel';
    // If your stored values are NL (as in your working filter), keep NL as canonical.
    // For safety, map DE/EN tokens back to NL canonical where possible:
    if(v.indexOf('blue')>-1 || v.indexOf('blau')>-1) return 'blauw';
    if(v.indexOf('black')>-1 || v.indexOf('schwarz')>-1) return 'zwart';
    if(v.indexOf('white')>-1 || v.indexOf('weiß')>-1 || v.indexOf('weiss')>-1) return 'wit';
    if(v.indexOf('yellow')>-1 || v.indexOf('gelb')>-1) return 'geel';
    if(v.indexOf('green')>-1 || v.indexOf('grün')>-1 || v.indexOf('grun')>-1) return 'groen';
    if(v.indexOf('red')>-1 || v.indexOf('rot')>-1) return 'rood';
    if(v.indexOf('orange')>-1) return 'oranje';
    if(v.indexOf('purple')>-1 || v.indexOf('violett')>-1) return 'paars';
    if(v.indexOf('pink')>-1 || v.indexOf('rosa')>-1) return 'roze';
    if(v.indexOf('brown')>-1 || v.indexOf('braun')>-1) return 'bruin';
    if(v.indexOf('grey')>-1 || v.indexOf('gray')>-1 || v.indexOf('grau')>-1) return 'grijs';
    if(v.indexOf('silver')>-1 || v.indexOf('silber')>-1) return 'zilver';
    if(v.indexOf('gold')>-1 || v.indexOf('goud')>-1) return 'goud';
    if(v.indexOf('aqua')>-1) return 'aqua';
    if(v.indexOf('beige')>-1) return 'beige';
    // fallback: keep original normalized (covers e.g. "brons", "antraciet")
    return v;
  }

  function _activeKleuren(){
    var sp = new URLSearchParams(window.location.search || '');
    var vals = [];
    sp.forEach(function(v,k){
      if(k === 'filter.v.m.custom.kleur' || k === 'filter.v.m.custom.kleur[]' || k === 'filter.v.m.custom.kleur%5B%5D'){
        if(v) vals.push(v);
      }
    });
    // In your theme, sometimes parameters are serialized without URLSearchParams seeing duplicates; so also parse raw query:
    if(!vals.length && window.location.search){
      window.location.search.replace(/^\?/,'').split('&').forEach(function(pair){
        var p = pair.split('=');
        if(p[0] === 'filter.v.m.custom.kleur' || p[0] === 'filter.v.m.custom.kleur[]'){
          if(p[1]) vals.push(decodeURIComponent(p[1].replace(/\+/g,' ')));
        }
      });
    }
    return vals;
  }

  function _localizeActiveChips(){
    var locale = _getLocale();
    var dict = _kleurLabels[locale] || _kleurLabels.nl;

    // Chips in active facet area (links) and tag bar (span.actFilter)
    var $chips = window.jQuery ? jQuery('.active-facets a, .sidebar_tags a.actFilter, .sidebar_tags .actFilter') : null;
    if(!$chips || !$chips.length) return;

    $chips.each(function(){
      var $el = jQuery(this);
      // find the raw value if present
      var raw = $el.attr('data-value') || $el.data('value') || '';
      // if not present, try to infer from href query param
      if(!raw){
        var href = $el.attr('href') || '';
        var m = href.match(/filter\.v\.m\.custom\.kleur=([^&]+)/);
        if(m && m[1]) raw = decodeURIComponent(m[1].replace(/\+/g,' '));
      }
      if(!raw) return;

      var key = _canon(raw);
      if(!dict[key]) return;

      // Replace only the visible text node (keep icons/x)
      // Common: <a>Blauw <span class="actFilter"></span></a> or similar
      var txt = $el.clone().children().remove().end().text().trim();
      if(txt && txt !== dict[key]){
        // Replace first text node safely
        var node = this.firstChild;
        while(node && node.nodeType !== 3){ node = node.nextSibling; }
        if(node && node.nodeType === 3){
          node.nodeValue = ' ' + dict[key] + ' ';
        } else {
          // fallback
          $el.contents().filter(function(){return this.nodeType===3;}).first().replaceWith(' ' + dict[key] + ' ');
        }
      }
    });
  }

  function _applyVariantImages(){
    var active = _activeKleuren();
    if(!active || !active.length) return;

    var activeKeys = active.map(_canon);

    var cards = document.querySelectorAll('[data-kleur-variants]');
    if(!cards || !cards.length) return;

    cards.forEach(function(card){
      var raw = card.getAttribute('data-kleur-variants');
      if(!raw) return;

      var variants;
      try { variants = JSON.parse(raw); } catch(e){ return; }
      if(!Array.isArray(variants) || !variants.length) return;

      // find best match: exact key match first
      var match = null;
      for(var i=0;i<variants.length;i++){
        var v = variants[i];
        if(!v || !v.kleur) continue;
        var vk = _canon(v.kleur);
        if(activeKeys.indexOf(vk) !== -1){
          match = v; break;
        }
      }
      if(!match || !match.img) return;

      // prefetch
      try { var im = new Image(); im.src = match.img; } catch(e){}

      // swap tile image (background)
      var imgDiv = card.querySelector('.gitem-img');
      if(imgDiv){
        imgDiv.style.backgroundImage = 'url(\"' + match.img + '\")';
        imgDiv.setAttribute('data-bgset', match.img);
        imgDiv.classList.add('lazyloaded');
        imgDiv.classList.remove('lazyload');
      }

      // update link to variant
      var a = card.querySelector('a.gimg-link');
      if(a && match.id){
        try{
          var u = new URL(a.getAttribute('href'), window.location.origin);
          u.searchParams.set('variant', match.id);
          a.setAttribute('href', u.pathname + u.search);
        } catch(e){}
      }
    });
  }

  // Run now + after ajax updates + after back/forward
  function _runAll(){
    if(window.jQuery){
      _localizeActiveChips();
    }
    _applyVariantImages();
  }

  document.addEventListener('DOMContentLoaded', function(){ _runAll(); });

  // Hook into your theme ajaxfilter complete via jQuery ajaxComplete (non-invasive)
  if(window.jQuery){
    jQuery(document).ajaxComplete(function(){
      _runAll();
    });
  }

  window.addEventListener('popstate', function(){ setTimeout(_runAll, 0); });
})();




/* =========================================================
   Kleur active-chip dedupe (voorkomt 2x dezelfde chip bij alias-OR)
   - verandert NIETS aan filtering (URL kan meerdere values bevatten)
   - verbergt alleen dubbele zichtbare chips met dezelfde canon-kleur
   ========================================================= */
(function () {
  function _stripDiacritics(s){
    try { return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,''); }
    catch(e){ return (s || '').toLowerCase(); }
  }
  function _canonColorKey(label){
    var t = _stripDiacritics(label).replace(/ß/g,'ss').trim();
    // remove common UI cruft (x, times, etc.)
    t = t.replace(/[×✕✖x]\s*$/i,'').trim();
    // quick contains checks (handles zusammengesetzt: "hellblau", "natuerlich", etc.)
    if (/(blau|blue|blauw)/.test(t)) return 'blauw';
    if (/(schwarz|black|zwart)/.test(t)) return 'zwart';
    if (/(weiss|weiß|white|wit)/.test(t)) return 'wit';
    if (/(grun|gruen|green|groen)/.test(t)) return 'groen';
    if (/(gelb|yellow|geel)/.test(t)) return 'geel';
    if (/(rot|red|rood)/.test(t)) return 'rood';
    if (/(violett|lila|purple|paars)/.test(t)) return 'paars';
    if (/(grau|gray|grey|grijs)/.test(t)) return 'grijs';
    if (/(beige)/.test(t)) return 'beige';
    if (/(taupe)/.test(t)) return 'taupe';
    if (/(bronze|brons)/.test(t)) return 'brons';
    if (/(anthrazit|antraciet)/.test(t)) return 'antraciet';
    if (/(aqua)/.test(t)) return 'aqua';
    if (/(turquoise|turkoois|tuerkis)/.test(t)) return 'turquoise';
    if (/(multicolor)/.test(t)) return 'multicolor';
    if (/(orange|oranje)/.test(t)) return 'oranje';
    if (/(naturel|natural|naturlich|natuerlich|natürlich)/.test(t)) return 'naturel';
    return null;
  }

  function _chipNodes(){
    // de meest voorkomende chip nodes in themes
    var sel = [
      '.actFilter',
      '.flTgs a', '.flTgs span',
      '.filterTags a', '.filterTags span',
      '.active-facets__button',
      '.active-facets__item a', '.active-facets__item button',
      '.js-facet-remove', '.facet-remove',
      '.selected-filter', '.selectedFilters a', '.selectedFilters span'
    ].join(',');
    return Array.prototype.slice.call(document.querySelectorAll(sel));
  }

  function dedupeKleurChips(){
    var seen = Object.create(null);
    _chipNodes().forEach(function(el){
      // do not touch "clear all"
      var txt = (el.textContent || '').trim();
      if (!txt) return;
      if (/alles\s+l(ö|o)schen/i.test(txt) || /clear\s+all/i.test(txt) || /tout\s+effacer/i.test(txt)) return;

      var key = _canonColorKey(txt);
      if (!key) return;

      if (seen[key]) {
        el.style.display = 'none';
      } else {
        seen[key] = true;
        el.style.display = '';
      }
    });
  }

  // throttle to avoid running too often on big DOM swaps
  var _scheduled = false;
  function schedule(){
    if (_scheduled) return;
    _scheduled = true;
    requestAnimationFrame(function(){
      _scheduled = false;
      dedupeKleurChips();
    });
  }

  document.addEventListener('DOMContentLoaded', schedule);

  // Observe changes (ajaxfilter replaces chunks)
  var mo = new MutationObserver(schedule);
  mo.observe(document.documentElement, {subtree:true, childList:true});
})();
/* =========================================
   Ensure missing active facet chips are shown
   - vult ontbrekende chips aan op basis van
     aangevinkte checkbox facets in #CollectionFiltersForm
   ========================================= */
(function () {
  function getFacetForm() {
    return document.getElementById('CollectionFiltersForm');
  }

  function getActiveFacetsWrap() {
    return document.querySelector('.active-facets');
  }

  function getCheckedFacetInputs() {
    var form = getFacetForm();
    if (!form) return [];
    return Array.prototype.slice.call(
      form.querySelectorAll('input[type="checkbox"][name^="filter."]:checked')
    );
  }

  function normalizeText(s) {
    return (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function getExistingChipLabels() {
    var wrap = getActiveFacetsWrap();
    if (!wrap) return {};
    var map = Object.create(null);

    wrap.querySelectorAll('a, button, span').forEach(function (el) {
      var txt = normalizeText(el.textContent);
      if (txt) map[txt] = true;
    });

    return map;
  }

  function buildRemoveUrl(input) {
    try {
      var url = new URL(window.location.href);
      var name = input.getAttribute('name');
      var value = input.value;

      var next = [];
      url.searchParams.getAll(name).forEach(function (v) {
        if (v !== value) next.push(v);
      });

      url.searchParams.delete(name);
      next.forEach(function (v) {
        url.searchParams.append(name, v);
      });

      return url.pathname + url.search;
    } catch (e) {
      return '#';
    }
  }

  function getInputLabel(input) {
    var id = input.id;
    if (!id) return '';

    var label = document.querySelector('label[for="' + CSS.escape(id) + '"]');
    if (!label) return '';

    return (label.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function ensureMissingFacetChips() {
    var wrap = getActiveFacetsWrap();
    var form = getFacetForm();
    if (!wrap || !form) return;

    var existing = getExistingChipLabels();
    var checked = getCheckedFacetInputs();

    checked.forEach(function (input) {
      var label = getInputLabel(input);
      var norm = normalizeText(label);
      if (!label || existing[norm]) return;

      var a = document.createElement('a');
      a.className = 'actFilter js-facet-remove';
      a.href = buildRemoveUrl(input);
      a.setAttribute('data-value', input.value);
      a.textContent = label + ' ×';

      wrap.appendChild(a);
      existing[norm] = true;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    ensureMissingFacetChips();
  });

  if (window.jQuery) {
    jQuery(document).ajaxComplete(function () {
      ensureMissingFacetChips();
    });
  }

  window.addEventListener('popstate', function () {
    setTimeout(ensureMissingFacetChips, 0);
  });
})();
/* SWP (12-06-2026, v2): toon 2e productfoto bij aanraken op touch-apparaten.
   v2: geen directe reset bij touchcancel (scroll), min. zichtduur, geen
   transition-herstart bij aanraken van dezelfde kaart. */
(function(){
  if (!('ontouchstart' in window)) return;
  var active = null, shownAt = 0, hideTimer = null;
  function hide(){
    if(active){ active.classList.remove('touch-preview'); active = null; }
  }
  function scheduleHide(){
    if(!active) return;
    var elapsed = Date.now() - shownAt;
    var wait = Math.max(600, 900 - elapsed);
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, wait);
  }
  document.addEventListener('touchstart', function(e){
    var t = e.target;
    var img = (t && t.closest) ? t.closest('.gview-img') : null;
    if (img && img === active) { clearTimeout(hideTimer); return; }
    if (img && img.querySelector('.gitem-img.hover')) {
      clearTimeout(hideTimer);
      hide();
      img.classList.add('touch-preview');
      active = img;
      shownAt = Date.now();
    } else if (!img) {
      scheduleHide();
    }
  }, {passive:true});
  document.addEventListener('touchend', scheduleHide, {passive:true});
  document.addEventListener('touchcancel', scheduleHide, {passive:true});
})();
